<i18n>
{
    "en_US": {
        "no-title": "_(No title)_"
    },
    "fr_FR": {
        "no-title": "_(Aucun titre)_"
    }
}
</i18n>

<template>
    <div class="markdown-split-preview" :class="{ active: isMarkdownSplitVisible }">
        <button class="btn btn-primary" v-on:click="toggleMarkdownSplit">&times;</button>
        <h1 v-html="markdown(selectedNote.title)"></h1>
        <div v-html="markdown(selectedNote.content)"></div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import Renderer from "plugins/marked";

    export default {
        name: "Split",
        computed: {
            ...mapState("note", ["selectedNote"]),
            ...mapState("application", ["isMarkdownSplitVisible"])
        },
        watch: {
            isMarkdownSplitVisible: function(newValue) {
                if (newValue === false) {
                    var root = $(this.$el);
                    // Stopping all youtube video (if any)
                    root.find(".youtube-player-iframe").each(function() {
                        this.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"stopVideo\",\"args\":\"\"}", "*");
                    });
                    // Stopping all vimeo video (if any)
                    root.find(".vimeo-player-iframe").each(function() {
                        this.contentWindow.postMessage("{\"method\":\"unload\"}", "*");
                    });
                    // Stopping all dailymotion video (if any)
                    root.find(".dailymotion-player-iframe").each(function() {
                        this.contentWindow.postMessage("{\"command\":\"pause\",\"parameters\":[]}", "*");
                    });
                    // Stopping all facebook video (if any)
                    root.find(".facebook-player-container").each(function() {
                        // Ugly way but I couldn't find a better way...
                        var tmp = $(this).find(".facebook-player-iframe").detach();
                        tmp.appendTo($(this));
                    });
                }
            }
        },
        methods: {
            markdown: function(content) {
                if (content === "_(no title)_") {
                    return marked(this.$t("no-title"), { sanitize: true });
                }
                return marked(content, {
                    renderer: Renderer(),
                    sanitize: false,
                    highlight: function(code) {
                        return hljs.highlightAuto(code).value;
                    }
                });
            },
            ...mapMutations("application", ["toggleMarkdownSplit"])
        }
    }
</script>

<style scoped>
    .markdown-split-preview.active {
        left: 50% !important;
    }
    .markdown-split-preview {
        position: absolute;
        min-height: calc(100%) !important;
        height: calc(100%) !important;
        width: 50%;
        left: 100%;
        padding: 15px 30px;
        overflow: auto;
        border-left: 1px solid rgb(228, 234, 236);
        background-color: #FDFDFD;
        -webkit-transition: left 0.5s ease-in-out;
        -moz-transition: left 0.5s ease-in-out;
        -ms-transition: left 0.5s ease-in-out;
        -o-transition: left 0.5s ease-in-out;
        transition: left 0.5s ease-in-out;
    }
    .markdown-split-preview > div {
        padding-top: 5px;
        margin-top: 0;
        padding-left: 5px;
    }
    .btn-primary {
        position: absolute;
        right: 10px;
        top: 10px;
    }
    @media screen and (max-width: 630px) {
        .markdown-split-preview.active {
            left: 100% !important;
        }
    }
</style>